<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon"
                                                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12">
                    <div class="banner-title">消息</div>
                </van-col>
            </van-row>
        </div>
        <div class="dynamics">
            <div class="d-item">
                <div class="d-top">
                    <img @click="toFriendDesc(item.userId)" class="d-avatar"
                         :src="item.userAvatar ? item.userAvatar : defaultImg">
                    <div class="d-info">
                        <div class="d-username" @click="toFriendDesc(item.userId)">{{item.userNameRemark ?
                            item.userNameRemark : item.userName}}
                        </div>
                        <div class="d-time">{{item.createTime}}</div>
                    </div>
                </div>
                <div class="d-sport" v-if="item.sportId" @click="openDynamicDesc(item)">
                    <div class="icon-box">
                        <gps-baidu :gps-data="item.gpsData" :canvas-id="item.sportId"
                                   :sport-type="item.sportType"></gps-baidu>
                    </div>
                    <div class="s-info" v-if="!checkPower(item.sportType)">
                        <div class="s-num-box"><span class="s-num">{{(item.distance / 100000).toFixed(2)}}</span><span
                                class="s-num-unit">公里</span></div>
                        <div class="s-sub">
                            <img class="s-sub-icon" src="@/assets/share/home/map.png">
                            <span v-if="!(item.city&&item.district)">暂无地址信息</span>
                            <span v-if="item.city||item.district">{{item.cite}}{{item.district}}</span>
                        </div>
                    </div>
                    <div class="s-info" v-if="checkPower(item.sportType)">
                        <div class="s-num-box"><span class="s-num">{{item.powerGroupNum}}</span><span
                                class="s-num-unit">组</span></div>
                        <div class="s-sub">力量训练</div>
                    </div>
                    <div class="s-type"
                         :style="{'background-image':`url(${require(`@/assets/share/home/${item.sportType}.png`)}`}">
                        <div class="s-type-text">"{{item.sportType}}"</div>
                    </div>
                    <van-row>
                        <van-col span="8" v-if="item.sportType.indexOf('游泳') == -1">
                            <div class="d-desc-item">
                                <div class="desc-num">{{item.avgHeartrate}}</div>
                                <div class="desc-title">平均心率</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="item.sportType.indexOf('游泳') != -1">
                            <div class="d-desc-item">
                                <div class="desc-num">{{dealSwolf(item)}}</div>
                                <div class="desc-title">平均SWOLF</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="checkPower(item.sportType)">
                            <div class="d-desc-item d-desc-center">
                                <div class="desc-num">{{parseInt(item.calories/1000)}}</div>
                                <div class="desc-title">卡路里</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="!checkPower(item.sportType)">
                            <div class="d-desc-item d-desc-center">
                                <div class="desc-num">{{dealPach(item)}}</div>
                                <div class="desc-title">{{item.sportType.indexOf('游泳') != -1 ? '百米泳速' : '平均配速'}}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="d-desc-item">
                                <div class="desc-num">{{dealTime(item.actTime)}}</div>
                                <div class="desc-title">运动时长</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-ecg" v-if="item.ecgId" @click="openDynamicDesc(item)">
                    <van-row>
                        <van-col span="14">
                            <div class="d-ecg-left">
                                <div class="ecg-info">
                                    <div v-if="!item.isError" class="ecg-normal"></div>
                                    <div v-if="item.isError" class="ecg-error"></div>
                                    <div class="ecg-conclusion">{{item.conclusion}}</div>
                                </div>
                                <div class="ecg-from">由<span class="ecg-add">{{item.deviceName}}</span>采集</div>
                            </div>
                        </van-col>
                        <div class="ecg-chart" :id="item.ecgId"></div>
                    </van-row>
                </div>
                <div class="d-bottom">
                    <van-row>
                        <van-col span="12">
                            <div class="d-b-item d-b-item-left">
                                <img v-if="item.isLike" class="d-b-icon" src="@/assets/share/home/like.png"
                                     @click="like(item, 0)">
                                <img v-if="!item.isLike" class="d-b-icon" src="@/assets/share/home/unlike.png"
                                     @click="like(item, 1)">
                                <span class="like-num">{{item.likeNum}}</span>
                            </div>
                        </van-col>
                        <van-col span="12" @click="clickComment(item, 0, item)">
                            <div class="d-b-item">
                                <img class="d-b-icon" src="@/assets/share/home/comment.png">
                                <span class="comment-num">{{item.commentList.length > 0 ? item.commentList.length : '评论'}}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="d-comment" v-if="item.commentList.length > 0">
                    <div class="d-comment-box">
                        <div class="d-comment-item"
                             @click="clickComment(item, 1, c)"
                             v-for="(c, index) in item.commentList">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span class="comment-username">{{c.userNameRemark ? c.userNameRemark : c.userName}}</span></span>
                            <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{c.toUserNameRemark ? c.toUserNameRemark : c.toUserName}}：</span>
                            </span>
                            <span v-if="c.type == 0" class="comment-username">:</span>
                            {{c.content}}
                        </div>
                    </div>
                </div>
            </div>
            <van-popup v-model="showComment" position="bottom" style="background: #000000">
                <div class="apply-value">
                    <van-field v-model="commentInfo.content" :placeholder="commentInfo.type == 0 ? '评论':'回复'">
                        <template #button>
                            <van-button size="mini" type="primary" @click="sendComment">发送</van-button>
                        </template>
                    </van-field>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import gpsBaidu from "../../components/gpsBaidu";
    import {Dialog, Toast} from 'vant';
    import {SwitchTime, SwitchTimeToM} from '@/utils/dateUtils';
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'msgDesc',
        components: {
            gpsBaidu
        },
        data() {
            return {
                theme: 'light',
                defaultImg: require('@/assets/share/home/noImg.png'),
                item: {
                    commentList: []
                },
                commentInfo: {},
                showComment: false,
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getDesc();
        },
        methods: {
            back() {
                this.$router.back();
            },
            openDynamicDesc(item) {
                WebJSBridge.call("openDynamicDesc", {
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    userAvatar: item.userAvatar,
                    startSportTime: item.createTime
                }, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            getDesc() {
                this.$api.share.getDynamicsInfo({
                    ecgId: localStorage.getItem('cEcgId'),
                    sportId: localStorage.getItem('cSportId'),
                    sportType: localStorage.getItem('cSportType'),
                    startSportTime: localStorage.getItem('cSportStartTime')
                }).then(res => {
                    this.item = res.info
                    if (this.item.ecgId) {
                        this.$nextTick(function () {
                            this.drawEcg(this.item);
                        })
                    }
                })
            },
            toFriendDesc(userId) {
                if (userId != localStorage.getItem("userId")) {
                    localStorage.setItem("sharerId", userId);
                    this.$router.push({
                        name: 'friendDescLight',
                        query: {
                            theme: this.theme
                        }
                    })
                }
            },
            checkPower(sportType) {
                let tag = 0;
                if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                    tag = 1;
                }
                return tag;
            },
            dealTime(n) {
                return SwitchTime(n);
            },
            dealSwolf(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let swolf = item.avgSwolf;
                if (is806) {
                    swolf = parseInt(swolf / 10)
                }
                return swolf;
            },
            dealPach(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let value = item.avgSpeed;
                if (!is806 && (item.sportType != '室内游泳')) {
                    value = value == 0 ? 0 : 10000 / (value ? value : 1);
                }
                if (!is806 && (item.sportType == '室内游泳')) {
                    value = value == 0 ? 0 : 1000 / (value ? value : 1);
                }
                return SwitchTimeToM(value);
            },
            clickComment(item, type, c) {
                this.currentD = item;
                this.commentInfo = {
                    ecgId: item.ecgId,
                    sportType: item.sportType,
                    sportId: item.sportId,
                    startSportTime: item.createTime,
                    type: type,
                    toUserId: c.userId,
                    content: '',
                    userId: localStorage.getItem('userId'),
                    userAvatar: localStorage.getItem('userAvatar').indexOf('http') != -1 ? localStorage.getItem('userAvatar') : '',
                    userName: localStorage.getItem('userName'),
                    toUserName: c.userNameRemark ? c.userNameRemark : c.userName
                }
                this.showComment = true;
            },
            sendComment() {
                this.$api.share.comment(this.commentInfo).then(res => {
                    this.item.commentList.push(this.commentInfo);
                    this.$set(this.item, 'commentList', this.item.commentList);
                    this.showComment = false;
                    this.commentInfo = {}
                }).catch(e => {
                    Toast({message: '发言不符合社区规范！'});
                })
            },
            drawEcg(item) {
                let a = item.ecgFragment;
                let b = a.split(',');
                let c = [];
                for (let i = 0; i < b.length; i++) {
                    c.push(i);
                }
                let myChart = this.$echarts.init(document.getElementById(item.ecgId));
                myChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0,
                        left: 10,
                        right: 10
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: c
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: b,
                            type: 'line',
                            symbol: 'none',
                            color: '#DC3D5C',
                            smooth: false,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            },
            like(item, isLike) {
                this.$api.share.like({
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    startSportTime: item.createTime,
                    isLike,
                    toUserId: item.userId
                }).then(res => {
                    this.$set(item, 'isLike', isLike);
                    if (isLike) {
                        this.$set(item, 'likeNum', item.likeNum + 1);
                    } else {
                        this.$set(item, 'likeNum', item.likeNum - 1);
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .dynamics {
        margin: 15px 15px;
    }

    .d-item {
        width: 100%;
        background: var(--bg-color-2);
        margin-bottom: 10px;
        border-radius: 6px;
        padding-bottom: 6px;
    }

    .d-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        border: 2px solid var(--text-color-1);
        margin: 14px 10px 15px 17px;
        vertical-align: top;
    }

    .d-info {
        display: inline-block;
        margin-top: 14px;
    }

    .d-username {
        opacity: 0.9;
        font-size: 14px;
        line-height: 24px;
        color: var(--text-color-1);
    }

    .d-time {
        opacity: 0.4;
        font-size: 12px;
        color: var(--text-color-1);
    }

    .icon-box {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        background: var(--text-color-1);
        border: 1px solid #343434;
        margin: 12px 10px 10px 15px;
        display: inline-block;
        vertical-align: top;
    }

    .s-info {
        display: inline-block;
    }

    .s-num-box {
        margin-top: 3px;
    }

    .s-num-unit {
        opacity: 0.7;
        font-size: 11px;
    }

    .s-num {
        font-family: BlackItalic;
        font-size: 35px;
        opacity: 1;
        letter-spacing: 3px;
        margin-right: 2px;
    }

    .s-sub-icon {
        width: 11px;
        vertical-align: top;
    }

    .s-sub {
        opacity: 0.6;
        margin-top: 5px;
        font-size: 11px;
    }

    .s-type {
        float: right;
        background-size: contain;
        width: 72px;
        height: 72px;
        margin-right: 5px;
    }

    .s-type-text {
        text-align: center;
        opacity: 0.6;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
    }

    .d-sport {
        width: 100%;
    }

    .d-desc-item {
        text-align: center;
        margin-bottom: 16px;
    }

    .d-desc-center {
        /*border-left: 1px solid #FFFFFF;*/
        position: relative;
    }

    .d-desc-center:before {
        content: '';
        position: absolute;
        left: 0;
        top: 35%;
        bottom: auto;
        right: auto;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .d-desc-center:after {
        content: '';
        position: absolute;
        left: auto;
        top: 35%;
        bottom: auto;
        right: 0;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .desc-num {
        font-family: Bold;
        font-size: 24px;
    }

    .desc-title {
        color: #A5A5A5;
        font-size: 11px;
    }

    .d-bottom {
        border-top: 1px solid var(--text-color-1);
    }

    .d-b-item {
        text-align: center;
        font-size: 11px;
        line-height: 22px;
        margin-top: 6px;
        color: #A5A5A5;
    }

    .d-b-icon {
        width: 22px;
        vertical-align: bottom;
    }

    .d-b-item-left {
        position: relative;
    }

    .d-b-item-left:after {
        content: '';
        position: absolute;
        left: auto;
        top: 13%;
        bottom: auto;
        right: 0;
        height: 70%;
        width: 1px;
        background-color: #000000;
    }

    .ecg-info {
        position: relative;
    }

    .ecg-normal {
        width: 6px;
        height: 6px;
        background: #20d38f;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-error {
        width: 6px;
        height: 6px;
        background: #E24160;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-conclusion {
        display: inline-block;
        font-size: 15px;
        color: #E6E6E6;
        margin-left: 25px;
        margin-top: 10px;
    }

    .ecg-from {
        color: #A5A5A5;
        font-size: 12px;
        margin-left: 15px;
        margin-top: 5px;
    }

    .ecg-add {
        font-weight: bold;
        color: #E6E6E6 !important;
        margin: 0 2px;
    }

    .d-ecg-left {
        margin: 5px 0 15px 0;
    }

    .d-ecg {
        position: relative;
    }

    .ecg-chart {
        position: absolute;
        right: 0;
        top: 0px;
        width: 150px;
        height: 73px;
    }

    .d-comment {
        background: #000000;
        border-radius: 6px;
        margin: 6px 10px 6px 10px;
    }

    .d-comment-box {
        padding: 6px 12px;

    }

    .d-comment-item {
        color: #999999;
        line-height: 26px;
        font-size: 14px;
    }

    .comment-avatar {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        vertical-align: middle;
    }

    .comment-username {
        color: #E6E6E6;
    }

    /deep/ .van-cell {
        background-color: #202020 !important;
        border-radius: 6px;
    }

    /deep/ input {
        background-color: transparent;
        color: #E9E9E9;
        font-size: 14px;
        caret-color: #20D38F;
    }

    /deep/ input::-webkit-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

</style>



// WEBPACK FOOTER //
// src/views/shareLight/19msgDesc.vue